import React, { useEffect, useState } from 'react';
import {
  useSchedulingContext,
  useSchedulingUpdateContext,
} from '../../../context';
import ReviewAndSubmitStepPresenter from './ReviewAndSubmitStepPresenter';
import {
  EmptyContactDetails,
  ReviewAndSubmitDetails,
} from '../../../../api/models';

export interface ReviewAndSubmitStepWrapperProps {
  onSubmit: () => void;
}

const ReviewAndSubmitStepWrapper: React.FC<ReviewAndSubmitStepWrapperProps> = (
  props: ReviewAndSubmitStepWrapperProps
) => {
  const schedulingDetails = useSchedulingContext();
  const schedulingUpdateContext = useSchedulingUpdateContext();

  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  useEffect(() => {
    if (loaded && schedulingDetails.reviewAndSubmitDetails) {
      props.onSubmit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schedulingDetails.reviewAndSubmitDetails]);

  const onMobilePhoneChanged = (value: string) => {
    schedulingUpdateContext.changeSchedulingDetails({
      ...schedulingDetails,
      contactInfoDetails: {
        ...(schedulingDetails.contactInfoDetails?.patientContactDetails ??
          EmptyContactDetails),
        patientContactDetails: {
          ...(schedulingDetails.contactInfoDetails?.patientContactDetails ??
            EmptyContactDetails),
          mobileNumber: value,
        },
      },
    });
  };

  const onSubmit = (reviewAndSubmitDetails: ReviewAndSubmitDetails) => {
    schedulingUpdateContext.changeSchedulingDetails({
      ...schedulingDetails,
      reviewAndSubmitDetails: { ...reviewAndSubmitDetails },
    });
  };

  return (
    <ReviewAndSubmitStepPresenter
      schedulingDetails={schedulingDetails}
      onMobilePhoneChanged={onMobilePhoneChanged}
      onSubmit={onSubmit}
    />
  );
};

export default ReviewAndSubmitStepWrapper;
